import {EarlyAccessFeatureStatus} from 'app/earlyAccess/EarlyAccessFeatureStatus';

export interface featureFlag {
  name: string;
  slug: string;
  availableUntil: Date | number;
  defaultValue?: EarlyAccessFeatureStatus;
}

const PREFIX = 'feat_';

const featureFlags: featureFlag[] = [];

export {featureFlags};
